import { getRouteParam } from '@rad/hooks/useRouting';
import { Permission } from '../common/routes/types';
import { useAuth } from './useAuth';
// Whoever manages a tour opens its pages before visitors can, to check them. A preview reads the
// tour through the endpoint that checks that permission itself, so a forged parameter reaches
// nothing a visitor may not see.
export const useTourPreview = () => {
    const [auth] = useAuth();
    return getRouteParam('preview') !== null &&
        auth.hasPermission([Permission.ToursRead, Permission.SystemDistricts]);
};
// Keeps a preview a preview from one of the tour's pages to the next.
export const previewUrl = (url, previewing) => previewing ? `${url}?preview` : url;
